import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PayslipHistory, HistoryEntry } from "../components/PayslipHistory";
import { initDB, getAllPayslips, deletePayslipFromDB } from "../utils/db";

const RETENTION_DAYS = 90;

const HistoryPage = () => {
  const navigate = useNavigate();
  const [history, setHistory] = useState<HistoryEntry[]>([]);
  const [loading, setLoading] = useState(true);

  // Load Data on Mount
  useEffect(() => {
    const loadData = async () => {
      try {
        await initDB();
        await refreshHistory();
      } catch (e) {
        console.error("Error loading history", e);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const refreshHistory = async () => {
    const data = await getAllPayslips();
    const now = Date.now();
    const cutoff = now - RETENTION_DAYS * 24 * 60 * 60 * 1000;

    const validHistory: HistoryEntry[] = [];

    // Filter and Auto-Cleanup
    for (const record of data) {
      if (record.item.createdAt < cutoff) {
        await deletePayslipFromDB(record.item.id);
      } else {
        validHistory.push({
          id: record.item.id,
          createdAt: record.item.createdAt,
          details: record.decryptedDetails,
          letterhead: record.item.letterhead,
          signature: record.item.signature,
          primaryColor: record.item.primaryColor,
          contentMargin: record.item.contentMargin,
          signaturePadding: record.item.signaturePadding,
        });
      }
    }
    setHistory(validHistory);
  };

  const handleBack = () => {
    navigate("/");
  };

  // The Magic Logic: Send data back to Home
  const handleLoad = (entry: HistoryEntry) => {
    navigate("/", {
      state: {
        loadedData: entry.details,
        loadedLetterhead: entry.letterhead,
        loadedSignature: entry.signature,
        loadedColor: entry.primaryColor,
        loadedMargin: entry.contentMargin,
        loadedSignaturePadding: entry.signaturePadding,
      },
    });
  };

  const handleDelete = async (id: string) => {
    // The Modal logic is inside PayslipHistory, so we just perform the action here
    await deletePayslipFromDB(id);
    await refreshHistory();
  };

  return (
    <div
      className="app-container"
      style={{ minHeight: "100vh", paddingBottom: "4rem" }}
    >
      {/* Header Section */}
      <div
        style={{
          backgroundColor: "white",
          boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
        }}
      >
        <div
          style={{
            maxWidth: "1280px",
            margin: "0 auto",
            padding: "1.5rem 1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            <h1
              style={{
                fontSize: "1.5rem",
                fontWeight: "bold",
                color: "#111827",
              }}
            >
              Payslip History
            </h1>
            <p style={{ color: "#6b7280", fontSize: "0.875rem" }}>
              Manage your saved records
            </p>
          </div>
          <button
            onClick={handleBack}
            className="btn btn-primary"
            style={{
              backgroundColor: "white",
              color: "#374151",
              border: "1px solid #d1d5db",
            }}
          >
            ← Back to Generator
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div
        style={{ maxWidth: "1280px", margin: "0 auto", padding: "2rem 1rem" }}
      >
        {loading ? (
          <div
            style={{ textAlign: "center", marginTop: "3rem", color: "#6b7280" }}
          >
            Loading records...
          </div>
        ) : (
          <PayslipHistory
            history={history}
            onLoad={handleLoad}
            onDelete={handleDelete}
          />
        )}
      </div>
    </div>
  );
};

export default HistoryPage;
